import { CARRIER_KEY, RECAP_KEY, THANKS_KEY, WELCOME_KEY } from '../baseRoutePaths';

export const NGBAddress = 'NGB Genetics srl, via Ruggero Grieco 5/1A, Bologna, 40133';

export const formTitles: string[] = [
  'Dati generali',
  'Disturbi',
  'Patologie',
  'Intolleranze diagnosticate',
  'Allergie diagnosticate',
  'Farmaci',
  'Modalità di spedizione',
  'Corriere',
];

export const formSubtitles: string[] = [
  'Per cominciare, qualche informazione su di te',
  'Soffri di qualcuno dei seguenti disturbi?',
  'Soffri di qualcuna di queste patologie?',
  'Segna qui solo le intolleranze diagnosticate da un medico. Non indicare quelle sospette o non ufficialmente diagnosticate',
  'Segna qui solo le allergie diagnosticate con test allergologici validati (prick test, analisi su sangue, test di provocazione orale)',
  'Assumi alcuni tra i seguenti farmaci?',
  'Vuoi prenotare il ritiro del campione?',
  'Inserisci i dati che invieremo al corriere per il ritiro del campione',
];

export const descriptions: string[] = [
  '',
  `<p>Indica <span class="font-bold">lieve</span> se il disturbo è occasionale fino a una o due volte al mese e non c'è prescrizione di farmaci.<br />
  Indica <span class="font-bold">moderato</span> se il disturbo è con frequenza fino a una o due volte a settimana, e può esserci prescrizione di farmaci.<br />
  Indica <span class="font-bold">grave</span> se il disturbo è molto frequente, continuo anche più di tre giorni a settimana, e richiede l'uso di farmaci.<br />
  Se il disturbo è <span class="font-bold">assente</span> puoi non indicare nulla.</p>`,
  `<p>Indica <span class="font-bold">lieve</span> se la patologia è occasionale fino a una o due volte al mese e non c'è prescrizione di farmaci.<br />
  Indica <span class="font-bold">moderato</span> se la patologia è con frequenza fino a una o due volte a settimana, e può esserci prescrizione di farmaci.<br />
  Indica <span class="font-bold">grave</span> se la patologia è molto frequente, continuo anche più di tre giorni a settimana, e richiede l'uso di farmaci.<br />
  Se la patologia è <span class="font-bold">assente</span> puoi non indicare nulla.</p>`,
  '',
  '',
  'Se non si assumono farmaci di queste tipologie, non indicare nulla',
  `<p>Se temi di non essere in casa puoi usare uno <a href="https://www.tnt.it/contents/trova-fedex.html" target="new">dei punti di ritiro TNT</a>.<br />
  Basta che inserisci l'indirizzo del punto scelto invece del tuo e porti il campione al punto TNT il giorno prima del ritiro.</p>
  <p>Altrimenti puoi spedire il campione in autonomia a <span class="font-bold">${NGBAddress}</span></p>`,
  `<p>Se temi di non essere in casa puoi usare uno <a href="https://www.tnt.it/contents/trova-fedex.html" target="new">dei punti di ritiro TNT</a>.<br />
  Basta che inserisci l'indirizzo del punto scelto invece del tuo e porti il campione al punto TNT il giorno prima del ritiro.</p>
  <p>Altrimenti puoi spedire il campione in autonomia a <span class="font-bold">NGB Genetics srl, via Ruggero Grieco 5/1A, Bologna, 40133.</span></p>`,
];

export const pageTitles: Record<string, string> = {
  [WELCOME_KEY]: 'Inserimento dati',
  [CARRIER_KEY]: 'Dati per il ritiro del corriere:',
  [THANKS_KEY]: 'Grazie',
  [RECAP_KEY]: 'Recap anamnesi',
};

export const pageSubtitles: Record<string, string | ((name: string | boolean) => string)> = {
  [WELCOME_KEY]: (name) =>
    `<p>Ciao ${name}, ora ti chiederemo alcuni dati importanti per offrirti un servizio il più personalizzato possibile.</p>`,
  [CARRIER_KEY]:
    '<p>Controlla che i dati per il ritiro siano corretti prima di confermarli.<br /> Poi non sarà più possibile modificarli.</p>',
  [THANKS_KEY]: (isCarrierEnabled) =>
    isCarrierEnabled
      ? `<p>Tutti i dati sono stati inviati.<br />
  Ora devi solo stampare la lettera di vettura, attaccarla al pacco e attendere il passaggio del corriere.</p>`
      : `<p>Tutti i dati sono stati inviati.</p>`,
  [RECAP_KEY]:
    '<p>Abbiamo finito! Controlla che tutti i dati siano corretti prima di confermarli. Poi non sarà più possibile modificarli.</p>',
};
